// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-b16f58b2]{margin:10px 0}p[data-v-b16f58b2],ul[data-v-b16f58b2]{font-size:16px;line-height:1.5}", ""]);
// Exports
module.exports = exports;
